// One badge for the three states a document row can be in. Archived wins
// over expiry: an archived document is simply out of circulation.
export const documentStatusMeta = (document) => {
  if (document?.status === false) return { label: "Archived", tone: "secondary" };
  if (document?.is_expired) return { label: "Expired", tone: "danger" };
  return { label: "Active", tone: "success" };
};

const DocumentStatusBadge = ({ document, style }) => {
  const meta = documentStatusMeta(document);
  return (
    <span className={`badge badge-soft-${meta.tone}`} style={style}>
      {meta.label}
    </span>
  );
};

export default DocumentStatusBadge;
